import { Injectable } from '@angular/core';
import { AbstractSimpleListViewService } from '@examdojo/core/list-view';
import { PayoutRequestQuery, PayoutRequestUIModel } from '@examdojo/payments';
import { combineLatest, map } from 'rxjs';

@Injectable()
export class PayoutRequestsListService extends AbstractSimpleListViewService<PayoutRequestUIModel> {
  constructor(private readonly payoutRequestQuery: PayoutRequestQuery) {
    super();
  }

  override readonly data$ = combineLatest([
    this.payoutRequestQuery.selectCurrentPeriodRequest(),
    this.payoutRequestQuery.selectHistoricalRequests(),
  ]).pipe(
    map(([currentRequest, historicalRequests]) => {
      const allRequests = [...(historicalRequests || [])];
      if (currentRequest) {
        allRequests.unshift(currentRequest);
      }
      return allRequests;
    }),
  );

  override readonly loading$ = this.payoutRequestQuery.selectLoading();
  override readonly hasItems$ = this.data$.pipe(map((requests) => requests.length > 0));
}
